angular.module('unica_event.event_controllers')

.controller('EventEditController', function(
	$rootScope, $scope, $state, $stateParams,
	EventListService, EventEditService
) {

	$scope.pageTitle = 'Modifica evento';

	$scope.loadLocations();

	$rootScope.resetEventData();

	$rootScope.getServicesUsers();

	$rootScope.getPartnerList();

	$rootScope.getEvent( $stateParams.id );

	$scope.event_id = $stateParams.id;

	$scope.selectStage = { value: 0 };

	$scope.preselections = [];

	$scope.$on('event_loaded', function() {
		if ( $rootScope.eventData.stages ) {
			angular.forEach( $rootScope.eventData.stages, function( stage, stageIndex ) {
				if ( stage.preselection ) {
					$scope.preselections.push( { index: stageIndex, stage: stage, max: stage.max_preselections} );
				}
			});
		}
	});

	$scope.saveEvent = function() {
		$scope.showLoader();

		var eventData = angular.copy($rootScope.eventData);
		eventData.stages = $scope.parseDatesFromDateToTimestamp(eventData.stages);

		if ( eventData.votation_closing_date ) {
			eventData.votation_closing_date = moment( eventData.votation_closing_date ).format('YYYY-MM-DD');
		}

		angular.forEach( eventData.stages, function( stage, stageIndex ) {
			eventData.stages[stageIndex].preselection = 0;
			eventData.stages[stageIndex].max_preselections = 0;
		});

		eventData.preselections = [];
		angular.forEach( $scope.preselections, function( preselection ) {

			// var stageIndex = eventData.stages.findIndex(x => x.id === preselection.stage.id);
			var stageIndex = -1;
			eventData.stages.some(function(el, i) {
				if ( el.id == preselection.stage.id) {
					stageIndex = i;
					return true;
				}
			});

			if ( stageIndex > -1 ) {
				eventData.stages[stageIndex].preselection = 1;
				eventData.stages[stageIndex].max_preselections = parseInt( preselection.max );
			}

		});

		EventEditService
			.update(eventData)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {

					data.stages   = $rootScope.parseStages(data.stages);
					data.services = $rootScope.parseServices(data.services);
					$rootScope.eventData = data;
					console.log( data );

					$scope.showSuccessMsg('Evento aggiornato con successo!', '');
					//$state.go('app.event.list', { year: $rootScope.year });
				} else {
					$rootScope.manageError(data);
				}

			});

	};

	$scope.stage_preselection_selection = function () {
		// if ( $scope.preselections && $scope.selectStage.value && ( $scope.preselections.length == 0 || $scope.preselections.findIndex(x => x.stage.id === $scope.selectStage.value.id) ) ) {
		// 	var stageIndex = $rootScope.eventData.stages.findIndex( x => x.id === $scope.selectStage.value.id );
		// 	$scope.preselections.push( { index: stageIndex, stage: $scope.selectStage.value, max: 0} );
		// }
		if ( $scope.preselections && $scope.selectStage.value ) {


			var preselectionsIndex = -1;
			$scope.preselections.some(function(el, i) {
				if ( el.stage.id == $scope.selectStage.value.id ) {
					preselectionsIndex = i;
					return true;
				}
			});

			if ( $scope.preselections.length == 0 || preselectionsIndex == -1 ) {

				// var stageIndex = $rootScope.eventData.stages.findIndex( x => x.id === $scope.selectStage.value.id );
				var stageIndex = -1;
				$rootScope.eventData.stages.some(function(el, i) {
					if ( el.id == $scope.selectStage.value.id ) {
						stageIndex = i;
						return true;
					}
				});

				$scope.preselections.push( { index: stageIndex, stage: $scope.selectStage.value, max: 0} );
			}
		}

		$scope.selectStage = { value: 0 };
	}

	$scope.stage_preselection_remove = function ( index ) {
		$scope.preselections.splice(index,1);
	}

})

;